'use strict';
import account from './account';
import bonusProductsView from '../bonus-products-view';
import recommendations from './product/recommendations';
import cartStoreInventory from '../storeinventory/cart';
import samples from '../samples';
import login from './checkout/login';
import util from '../util';
import summarysection from './summarysection';
import productTile from '../product-tile';
import page from '../page';
import analytics from '../analytics';
import customModal from '../modal';
import validator from '../validator';
import reinsuranceCheckout from './reinsuranceCheckout';
import customDropdown from '../custom-dropdown';
import wishlist from './wishlist';
import googlePayExpress from '../adyen/googlePayExpress';
import ajax from '../ajax';
import paypalExpress from '../adyen/paypalExpress';
import quickview from '../quickview';

/**
 * @private
 * @function
 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
 */
function initializeEvents() {
	const $main = $('#main');
	const $cartCouponCode = $('.cart-coupon-code');

	let handler = util.debounce(function (e) {
		var error_msg = $cartCouponCode.find('.error');
		if (error_msg.length) {
			$(error_msg).hide();
		}
	}, 300);
	
	stickySideBarInit();
	$('#cart-table').on('click', '.item-edit-details a', function (e) {
		e.preventDefault();
		quickview.show({
			url: e.target.href,
			source: 'cart'
		});
	}).on('click', '.refill-offer-button', function (e) {
		e.preventDefault();
		let url = $(this).data('upsell-url');
		const upsellUuid = $(this).data('upsell-uuid');
		const upsellPid = $(this).data('upsell-pid');
		// url = util.appendParamToURL(url, 'format', 'ajax', 'source', 'cart', 'cartAction', 'update', 'upsell', 'true', 'uuid', upsellUuid, 'pid', upsellPid, 'Quantity', 1.0);
		url = util.appendParamToURL(url, 'format', 'ajax');
		url = util.appendParamToURL(url, 'source', 'cart');
		url = util.appendParamToURL(url, 'cartAction', 'update');
		url = util.appendParamToURL(url, 'upsell', 'true');
		url = util.appendParamToURL(url, 'uuid', upsellUuid);
		url = util.appendParamToURL(url, 'pid', upsellPid);
		url = util.appendParamToURL(url, 'Quantity', 1.0);
		
		$.ajax({
			type: 'POST',
			url: url,
			success: function (response) {
				analytics.refillOfferClick(e);
				page.refresh();
			},
			error: function (xhr, status, error) {
				console.error('Failed to add refill offer:', error);
				// Show user-friendly error message
			}
		});
	}).on('click', '.bonus-item-actions a, .item-details .bonusproducts a', function (e) {
		e.preventDefault();
		bonusProductsView.show(this.href);
	});

	//to prevent multiple submissions of the form when removing a product from the cart
	var removeItemEvent = false;
    $('button[name$="deleteProduct"], button[name$="addCoupon"], button[name$="deleteCoupon"],button[name$="addBonusProduct"]').unbind();
    $main.off('click').on('click','button[name$="deleteProduct"], button[name$="addCoupon"], button[name$="deleteCoupon"],button[name$="addBonusProduct"]', function (e) {
		if (!removeItemEvent) {
    		removeItemEvent = true;
    		e.preventDefault();
    		const $form = $('form#cart-items-form');
    		const action = $form &&  $form[0] ? $form[0].action : '';
    		const $removeButton = $(this);
    		let postData;
    		if($removeButton.attr('name') == 'dwfrm_cart_addBonusProduct') {
    			action = Urls.addBonusProductsAJAX;
    			postData = {
    				'pid': $removeButton.attr('data-pid'),
    				'bliUUID': $removeButton.attr('data-bliUUID'),
    				'format': 'ajax',
    			}
    		} else {
    			postData = $form.serialize() + '&' + $removeButton.attr('name') +'='+($removeButton.val() || $removeButton.attr('name'))+'&format=ajax';
    		}
    		postCartData(action, postData);
    	}
    });

	$('select.cart-qty-select').selectmenu({
		focus: function(event, ui) {},
		classes: {
			"ui-selectmenu-menu": "cart-qty-select"
		}
	});
	// product level bonus modal
	$main.on('click', '.minicart-promotion-threshold-full', function (e) {
		const $this = $(this);

		if ($this.find('.bonus-item-promo').length) {
			e.preventDefault();
			e.stopImmediatePropagation();
			const hrefPromo = $this.data('href');
			bonusProductsView.show(hrefPromo || this.href);
		}
	});

	
	$main.off('click', '.minicart-promotion-threshold').on('click', '.minicart-promotion-threshold', function (e) {
		const $this = $(this); // Cache the selector
	
		if ($this.data('pid')) {
			e.preventDefault();
			const $form = $('form#cart-items-form');
			const action = $form[0].action;
			let postData;
	
			if ($this.attr('name') === 'dwfrm_cart_addBonusProduct') {
				postData = {
					'pid': $this.attr('data-pid'),
					'bliUUID': $this.attr('data-bliUUID'),
					'format': 'ajax'
				};
				postCartData(Urls.addBonusProductsAJAX, postData);
			} else {
				postData = $form.serialize() + '&' + $this.attr('name') + '=' + ($this.val() || $this.attr('name')) + '&format=ajax';
				postCartData(action, postData);
			}
		}
	});
	

	$main.on('click', '.paypal-container a', function (e) {
		e.preventDefault();
		var cartCheckoutForm = $('.cart-action-checkout');
		if (cartCheckoutForm.length > 0) {
			cartCheckoutForm.attr('action', Urls.cartPaypalCheckout);
			cartCheckoutForm.submit();
		}
	});
	
	// Paypal Error Pop-up OK event
	$main.on('click', '#paypal-error-ok', function () {
		$('.error-form-wrapper').fadeOut(300);
	});

	$main.on('click', function(e) {
		if (!$(e.target).closest('.error-form').length){
			$('.error-form-wrapper').fadeOut(300);
		}
	});
	
	$main.on('click', 'button#cart-checkout-button', function (e) {
		e.preventDefault();
		var $form = $('#checkout-form');
		$form.find('button[name$="_cart_checkoutCart"]').trigger('click');
		enableDisableButtonBasedOnCoupon();
	});

	$main.on('click', 'button.removebutton, .user-action-remove button', function (e) {
		enableDisableButtonBasedOnCoupon();
		setTimeout(() => {
			reinsuranceCheckout.reinsuranceCartOnDocumentReady();
		}, 1000);
		reinsuranceCheckout.reinsuranceCartClickEvent();

		var dataPID = $(this).data('pid');
		var storedProductIds = JSON.parse(localStorage.getItem('storedproductid')) || [];
		storedProductIds = storedProductIds.filter(id => id != dataPID);
		localStorage.setItem('storedproductid', JSON.stringify(storedProductIds));
	});

	$main.on('keyup change', '.order-totals-table .cart-coupon-code input', handler);

	$main.on('click', '.cart-paypal-specific-popin .paypal-wrapper .adyen-checkout__paypal', function (e) {
		analytics.paypalExpressDatalayer()
	});

	giftMessageBox();

	$('input[name$="_shippingAddress_isGift"]').on('click', giftMessageBox);

	$('input[name$="_cart_isGift"]').on('click', function() {
		giftMessageBox();
		//Update Order Summary
		$('.ajax-loader').show();
		$.ajax({
			url: Urls.updateGiftWrap,
			dataType: 'html',
			success: function(response) {
				$('.order-estimation-details').html(response);
				$('.ajax-loader').hide();
			}
		})
	});
	
	//init apple pay button - ajax updates/refresh
	var appleStickyFlay = false;
	$(window).on("load", function () {
		stickyCTAs();
		appleStickyFlay = true;
		setTimeout(function () {
			const $element = $(".cart-mini-crosssell-slot");
            if($(".cart-mini-crosssell-slot .cart-mini-recommendation-container").length == 0) {
                $element.hide();
            }
			// hide cross sell if slot is empty
            if ($('.cart-mini-crosssell-slot div[id^="cq_recomm_slot"]').is(":empty")) {
                $element.hide();
            }
        }, 1000);
	});	
	
    $(document).on('applePayDisplayErr', function (event, json, string) {
	  // parameter is stocked in json.data here.
	 postAppleErr(json.dataErr);
	});
    
    
    //nationality
    $(document).on('applePayDisplayNationality', function (event, json, string) {
  	  // parameter is stocked in json.data here.
    	getApplePayDisplayNationality('applepay');
  	});
    
    //consent pop-up
    $(document).on('applePayDisplayConsent', function (event, json, string) {
  	  // parameter is stocked in json.data here.
    	getApplePayConsentModal();
  	});
}

function stickySideBarInit() {
	var productCount = $('.cart-item-quantity').html();
	var recommendationContainers = $('.recommendation-container').length;
	var isscroll = true;
	if (productCount != '1') {
		isscroll = true;
	} else if (productCount == '1') {
		isscroll = false;
	}
	if ($(window).width() >= 640 && isscroll) {
		if ($('.cart-right-column').length) {
			if($(window).width() >= 1600) {
				var stickySidebar = new StickySidebar('.cart-right-column', {
					topSpacing: 81,
					bottomSpacing: 50,
					resizeSensor: false,
					containerSelector: '.sidebar__inner',
					innerWrapperSelector: '.sidebar__inner'
				});
			} else {
				var stickySidebar = new StickySidebar('.cart-right-column', {
					topSpacing: 81,
					bottomSpacing: 50,
					resizeSensor: false,
					containerSelector: '.sidebar__inner',
					innerWrapperSelector: '.sidebar__inner'
				});
			}
		}
	}
}

function postCartData(action, postData, container, callback) {
	if ($('.overlay').length == 0) {
			$('body').append('<div class="overlay"></div>')
			$('.overlay').css('display', 'block');
		}
	let checkIfCrossSellLoaded;
	//check bonus availability
	var orderLevelBonus = $(".order-level-bonus").length;
	var ProductLevelBonus = $(".product-level-bonus").length;
	var promoMsgState = "";
    if($(".cart-item-qty .cart-promo-icon .icon").hasClass("icon-minus")) {
        promoMsgState = "true";
    } else {
        promoMsgState = "false";
    }
	$.ajax({
		type: 'POST',
		url: action,
		data: postData,
		success: function (response) {
			if($(".cart-mini-crosssell-slot").is(":visible")) {
                checkIfCrossSellLoaded = "true";
            }
			$('#primary').html(response);
			if ($('.cart-empty').length){
				$(window).scrollTop(0);
			} else {
				$(window).scroll();
			}
			$('.overlay').remove();
			if (promoMsgState == "false") {
                $(".cart-item-qty .cart-promo-description").addClass("hidden");
                $(".cart-item-qty .cart-promo-icon .icon").removeClass("icon-minus").addClass("icon-plus-cart");
            } else {
                $(".cart-item-qty .cart-promo-description").removeClass("hidden");
                $(".cart-item-qty .cart-promo-icon .icon").addClass("icon-minus").removeClass("icon-plus-cart");
            }
			$.ajax({
				type: 'GET',
				url: Urls.showMinicart,
				success: function (minCartData) {
					$('.header-container .minicart-link').html(minCartData);
					initializeAll();
					if(!checkIfCrossSellLoaded) {
						$(".cart-mini-crosssell-slot").hide();
					}
					reinsuranceCheckout.reinsuranceCartClickEvent();
					reinsuranceCheckout.reinsuranceWrapperReady();
					if($(".cart-coupon-code .error").length) {
						$("#add-coupon").prop("disabled", false);
					}
				},
				error: function () {
					page.refresh();
				}
			});
			if(action == Urls.addBonusProductsAJAX) {
				analytics.addBonusProductDataLayer('pid' in postData ? postData.pid : false);
			}
			analytics.gtmCouponApplied();
		},
		error: function () {
			page.refresh();
		}
	});

	// re-initialize Einstein Recommendation carousel
	setTimeout(function() {
		recommendations.init();
		// to reinit recommended product's quantity dropdown 
		$('.carousel-recommendations select').selectmenu();
		
		//trigger bonus modal
		if($(".order-level-bonus").length && orderLevelBonus == 0){
			$(".order-level-bonus").find(".select-bonus").trigger('click');
		}
		if($(".product-level-bonus").length && ProductLevelBonus==0){
			$(".product-level-bonus").find(".select-bonus").trigger('click');
		}
		
	}, 5000);
}

function initPromoMessage() {
    adjustPromoWrapperMargin();
    setupPromoIconClickHandler();
}

function adjustPromoWrapperMargin() {
    if($(".minicart-promotion-threshold").length) {
        $(".cart-promo-wrapper").css("margin-bottom", "0");
    }
}

function setupPromoIconClickHandler() {
    $('#main').on("click", ".cart-promo-icon", function(e) {
        e.stopImmediatePropagation();
        $(".cart-promo-description").toggleClass("hidden");
        togglePromoIcon($(this));
    });
}

function togglePromoIcon(iconElement) {
    const iconClass = iconElement.children().attr("class");
    const $iconWrapper = $(".cart-promo-icon .icon");
    if(iconClass && iconClass.includes("icon-minus")) {
        $iconWrapper.removeClass("icon-minus").addClass("icon-plus-cart");
    } else {
        $iconWrapper.removeClass("icon-plus-cart").addClass("icon-minus");
    }
}

// Enable or disable coupon form button based on coupon code
function enableDisableButtonBasedOnCoupon() {
	$('#add-coupon').prop('disabled', $('input[name$="couponCode"]').val() == "" ? true : false);
}

/**
 * @function
 * @description Initializes gift message box, if shipment is gift
 */
function giftMessageBox() {
	// show gift message box, if shipment is gift
	$('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val() !== 'true');
	$('.complimentary-gift-container').toggleClass('d-none', $('input[name$="_cart_isGift"]:checked').val() !== 'true');
}

function isGift() {
	const $checkoutForm = $('#checkout-form');
	const $giftContainer = $('.gift-container');
    const $giftCheckbox = $giftContainer.find('.input-checkbox');
    const $checkoutFormGift = $checkoutForm.find('.is-gift');
    const $giftTextarea = $giftContainer.find('.input-textarea');
    const $checkoutFormGiftMessage = $checkoutForm.find('.gift-message');
    const isGift = $giftCheckbox.is(':checked');
    const isGiftName = [
        $('#cart-items-form').attr('name'),
        'isGift'
    ].join('_');

    $checkoutFormGift.val(isGift);
    $checkoutFormGift.attr('name', isGiftName);
    $giftCheckbox.attr('checked', isGift);
    $('.gift-container').on('change', '.input-checkbox', function () {
        isGift = $(this).is(':checked');

        if (!isGift) {
            $giftTextarea.val('');
            $checkoutFormGiftMessage.val('');

            sessionStorage.removeItem('isGift');
            sessionStorage.removeItem('giftMessage');
        } else {
            $giftTextarea.keyup();
        }

        $checkoutFormGift.val(isGift);
    });
}

function giftMessage() {
    let giftMessage = sessionStorage.getItem('giftMessage') || '';
    let giftMessageName = [
        $('#cart-items-form').attr('name'),
        'giftMessage'
    ].join('_');

    const $giftMessageInput = $('#checkout-form .gift-message');
    const $giftMessageTextarea = $('.gift-container .input-textarea');
	const $formCaption = $('.gift-message-textarea .form-caption');
	const $checkoutButton = $('#checkout-form button');
	const $thirdPartyContainer = $('.third-party-container');

    $giftMessageInput.val(giftMessage);
    $giftMessageInput.attr('name', giftMessageName);
    $giftMessageTextarea.val(giftMessage);

    $giftMessageTextarea.on('keyup', util.debounce(function () {
        giftMessage = $(this).val().trim();
        if (giftMessage === '' || util.validateMessage(giftMessage)) {
            $giftMessageInput.val(giftMessage);
            $formCaption.removeClass('error-message');
            $formCaption.empty();
            $checkoutButton.prop('disabled', false);
            $thirdPartyContainer.css({
              'opacity': 1,
              'pointer-events': 'all'
            });
            sessionStorage.setItem('giftMessage', giftMessage);
        } else {
            $formCaption.addClass('error-message');
            $formCaption.text('Invalid message');
            $checkoutButton.prop('disabled', true);
            $thirdPartyContainer.css({
              'opacity': 0.5,
              'pointer-events': 'none'
            });
        }
    }, 300));
}

function updateCart() {
	$('.quantity-container select').on('selectmenuchange change', function () {
		var $form = $('form#cart-items-form');
		var action = $form[0].action;
		var postData = $form.serialize() +'&format=ajax';
					
		postCartData(action, postData);
		stickySideBarInit();
		cartPageMiniRecommendations();
	});
}

function cartCount() {
	if ($('.cart-empty').length) {
		sessionStorage.removeItem('isGift');
		sessionStorage.removeItem('giftMessage');
	}
}

$.fn.isInViewport = function () {
	if ($(this).length) {
		var elementTop = $(this).offset().top;
		var elementBottom = elementTop + $(this).outerHeight();
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();

		if(elementTop > viewportTop) {
		return elementBottom > viewportTop && elementTop < viewportBottom;
		} else {
			return false;
		}
	}
};

function stickyCTAs() {
	var isApplayPay = $('#applepay-container').find('.adyen-checkout__applepay__button').length !== 0 ? true : false;
	if(isApplayPay == true){
		$('.sticky-cta-wrapper').addClass('small-payment-cta');
	}
}

function stickyCheckout() {	// Not in Use 
	$(window).on('scroll', function () {
		var isApplayPay = $('#applepay-container').find('.adyen-checkout__applepay__button').length !== 0 ? true : false;
		var getAppleParent = $('#applepay-container').parent().attr("class"); 
		
		if ($(window).width() < 769 && $(".cart-empty-container-redesign").length === 0) {
			if ($('.cart-right-column .cart-actions button').isInViewport()) {
				$('.cart-actions-checkout').removeClass('show');
				if(isApplayPay == true){					
					$('#applepay-container').insertAfter('.text_divider'); //applepay on order summary section
				}
				
			} else {
				$('.cart-actions-checkout').addClass('show');
				$('.cart_page .trust-banner').css({
					"padding-bottom" : $('.cart-actions-checkout').height() + "px"
				});
				if(isApplayPay == true){
					$('.sticky-cta-wrapper').addClass('small-payment-cta');
					$('#applepay-container').insertAfter('.cart-sticky-button'); //applepay on sticky section
				}
			}

			$('.cart-right-column, .cart-right-column > div').removeAttr('style');
			$('.resize-sensor').remove();
		}else{
			$('.cart_page .trust-banner').removeAttr("style");
			$('.cart_page .trust-banner').css('paddingBottom', '0');
			if(getAppleParent != 'applepay-wrapper'){
				$('#applepay-container').insertAfter('.text_divider');
			}
		}
	});
}

function checkoutReinsurancePopup(dataContent) {
	$('a.cart-reinsuance-modal').on('click', function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		var $this = $(this);
		analytics.reinsuranceElements($this.attr('id'));	
		
		$.ajax({
			url: util.appendParamToURL($this.attr('href'), 'format', 'ajax'),
			method: 'GET'
		})
		.done(function (response) { 
			if (response) {
				customModal.createCustomModal('checkout-reinsurance-popup', '#modal-custom-placeholder');
				const $checkoutReinsurancePopup = $('.checkout-reinsurance-popup');
				$checkoutReinsurancePopup.find('.modal-body').html(response);
				if($(window).width() > 768) {
					$checkoutReinsurancePopup.find('.modal-body').scrollBox();
					$(window).trigger("resize.scrollBox");
				}
			}
		});
	});
}

//Apple Pay re-init (Not In Use)
function initApplePayBut(){	
	if($('#applepay-container').find('.adyen-checkout__applepay__button').length !== 0){
		 var userLocale = window.User.locale ? window.User.locale : 'en';
		 $('.adyen-checkout__applepay__button').attr('lang',userLocale);
		 $('.applepay-wrapper').css('display','block');
		try {
			$('.paypal-wrapper').removeClass('full-width');
			} catch (e) {
				console.error(e);
			}	 
	 }else{
		 $('.applepay-wrapper').css('display','none');
	 }
}

//Apple Pay Errormsg display
function postAppleErr(errData){	
	
	customModal.createCustomModal('apple-pay-error-popup', '#modal-custom-placeholder');
	$.ajax({
		type: 'POST',
		url: Urls.applePayErrorDisplay,
		data: {data: errData},
		success: function (response) {
			$('.apple-pay-error-popup').find('.modal-body').html(response);
		},
		error: function () {
			alert('something went wrong');
		}
	});	
}

//Apple Pay Display Nationality pop up
function getApplePayDisplayNationality(paymentMethod){	
	$.ajax({
		type: 'GET',
		url: Urls.applePayGetNationality,
		data: {},
		success: function (response) {
			customModal.createCustomModal('apple-pay-nationality-popup', '#modal-custom-placeholder');
			$('.apple-pay-nationality-popup').find('.modal-body').html(response);	
			const $nationalIDNumber = $('.nationalIDNumber .input-text');
			if($nationalIDNumber.val() !== '') {
				$nationalIDNumber.closest('.material-input').addClass('focus-in');
				$("<i class='icon_checkmark'></i>").insertBefore('.nationalidnumber');
			}		
		},
		error: function () {
			alert('something went wrong');
		}
	}).always(function (data) {

		 $('#apple-pay-nationality-popup').off().on('click', '#dwfrm_singleshipping_shippingAddress_save', function(e) {
			e.preventDefault();
			submitNationalityData(paymentMethod);
		});
		validator.changeFieldValidation();
	});		
}

/**
 * submit applepay shipping data
 */
function submitNationalityData(paymentMethod) {
	var $nationalityForm = $('#dwfrm_singleshipping_shippingAddress');
	$.ajax({
		type: 'POST',
		url: $nationalityForm.attr('action'),
		data: $nationalityForm.serialize() + '&dwfrm_singleshipping_shippingAddress_save=dwfrm_singleshipping_shippingAddress_save',
		success: function (response) {
			//get consent pop-up
			if($('#apple-pay-nationality-popup:visible').length > 0){//close nationality modal if open
				$('#apple-pay-nationality-popup .modal-close').trigger('click');
			}
			if(paymentMethod && paymentMethod == 'paypalECS') {
				getPayPalExpressConsentModal();
			}else {
				getApplePayConsentModal();
			}
		},
		error: function () {
			alert('something went wrong');
		}
	});
}

//trigger applepay consent modal pop up
function getApplePayConsentModal(){
	$.ajax({
		type: 'GET',
		url: Urls.cartApplePayConsentContent,
		data: {},
		success: function (response) {//reusing papypal express only classes for common validation.
			customModal.createCustomModal('cart-paypalexpress-popup', '#modal-custom-placeholder');
			$('.cart-paypalexpress-popup').find('.modal-body').html(response);
			clearConsentModalError();			
		},
		error: function () {
			alert('something went wrong');
		}
	});	
}

//trigger PayPal Express consent pop-up
function getPayPalExpressConsentModal() {
	$.ajax({
		type: 'GET',
		url: Urls.cartPaypalExpressContent,
		data: {},
		success: function (response) {
			customModal.createCustomModal('cart-paypalexpress-popup', '#modal-custom-placeholder');
			$('.cart-paypalexpress-popup').find('.modal-body').html(response);

			const payMethod = $('body').attr('data-paymentMethod');
			const expressModal = $('.cart-paypalexpress-popup');

			if (payMethod === 'googlepay_Express') {
				if (SitePreferences.ENABLE_GOOGLEPAY_EXPRESS_CHECKOUT) {
					googlePayExpress.mountGooglePayComponent();
				}
				expressModal.find('.paypal-expres-title, .btn-paypal-express, .consent-error-paypal').remove();
				expressModal.find('#googlepay-container').addClass('inactive');
			} 
			
			if (payMethod === 'paypalpay_Express') {
				paypalExpress.mountPaypalComponent();
				expressModal.find('.googlepay-express-title, .btn-googlepay-express, .consent-error-googlepay').remove();
				expressModal.find('#paypal-container').addClass('inactive');
			}

			clearConsentModalError();		
		},
		error: function () {
			alert('something went wrong');
		}
	});	
}

function clearConsentModalError() {
	var isTimer = null; 
	var $consentError = $(".cart-paypalexpress-popup .paypalexpress-popup-consent-error");
	var $termsandconditions = $(".cart-paypalexpress-popup .user-consent-container .input-checkbox.termsandconditions");
	if(isTimer) {
		clearTimeout(isTimer);
	}
	isTimer = setTimeout(function(){
		if($consentError.is(":visible")) {		
			$termsandconditions.prop('checked', false);
			$termsandconditions.removeClass("error");
			$consentError.remove();
		}
	}, 0)	
}

/**
 * Render terms and conditions overlay for paypal express.
 */

function cartPayPalExpressPopup() {
	const $modalCustomPlaceholder = $('#modal-custom-placeholder');
	$('#main').on('click keydown', 'a.button-cart-checkout.paypal-button, a.button-cart-checkout.googlepay-button', function(e) {
		if (e.type === "keydown") {
            if (e.key === " " || e.key === "Spacebar" || e.key === "Enter") {
                e.preventDefault(); // Prevent page scroll for Space
                $(this).trigger("click");
            }

            // Don't interfere with Tab or any other key
            return;
        }
		e.stopImmediatePropagation();

		$(this).hasClass('googlepay-button') && $('body').attr('data-paymentMethod' ,'googlepay_Express');
		$(this).hasClass('paypal-button') && $('body').attr('data-paymentMethod' ,'paypalpay_Express');
		if ($(this).hasClass('paypal-button')) {
			analytics.cartPaymentDataLayer('paypal Cart');
		}
		if ($(this).hasClass('googlepay-button')) {
			analytics.cartPaymentDataLayer('googlepay Cart');
		}

		if(Constants.CURRENT_MARKETID == 'it' || Constants.CURRENT_MARKETID == 'es') {
			getApplePayDisplayNationality('paypalECS'); // calling the same modal which we're using for apple pay.
		}else {
			getPayPalExpressConsentModal();
		}
	});
	
	$modalCustomPlaceholder.on('click', '#cart-paypalexpress-popup .applepaySubmit, #cart-paypalexpress-popup #paypal-container, #cart-paypalexpress-popup #googlepay-container', function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();
		analytics.googlePayTracking();
		var href = $(this).attr('href'),
			$termsCheckbox = $('#cart-paypalexpress-popup input[id$="_userconsent_termsandconditions"]'),
			$termsErrorMsg = $('#cart-paypalexpress-popup .paypalexpress-popup-consent-error');
	
		if($termsCheckbox.is(':checked')) {
			$('.btn-paypal-express').attr("disabled",true);
			$termsErrorMsg.hide();
			$termsCheckbox.removeClass('error');
			$(".paypal-wrapper .btn-paypal-express").removeClass('disabled');
			if($(this).hasClass("applepaySubmit")){//applepay ajax call
				$.ajax({
					method: 'POST',
					url: href,
					data: {},
					success: function success(data) {
					if (data.error) {
						$('.btn-paypal-express').attr("disabled",true);
						console.error(data.error);
						const parser = new URL(window.location);
						parser.searchParams.set('appleAuthResult', 'true');
						window.location = parser.href;
					} else {
						window.location.href = data.continueUrl;
					}
					},
					error: function error(err) {
						console.error(err); 
						$('.btn-paypal-express').attr("disabled",true);
						const parser = new URL(window.location);
						parser.searchParams.set('appleAuthResult', 'true');
						window.location = parser.href;
					}
				});
			}
		} else {
			$termsErrorMsg.show();
			$termsCheckbox.addClass('error');
			$("#googlepay-container, #paypal-container").addClass('disabled');
		}
	});

	$modalCustomPlaceholder.on('change', '#cart-paypalexpress-popup input[id$="_userconsent_termsandconditions"]', function(){
        var $termsErrorMsg = $('#cart-paypalexpress-popup .paypalexpress-popup-consent-error');
        if($(this).is(':checked')) {
            $termsErrorMsg .hide();
			$(this).removeClass('error');
			$("#googlepay-container, #paypal-container").removeClass('inactive disabled');
        }  else {
            $termsErrorMsg .show();
			$(this).addClass('error');
			$("#googlepay-container, #paypal-container").addClass('inactive').removeClass('disabled');
        }
    });

	$modalCustomPlaceholder.on('click', "#gpay-button-online-api-id", function(){
        analytics.googlePayTracking();
    });

	// toggle consent checkbox show more content 
	$modalCustomPlaceholder.on('click', '#cart-paypalexpress-popup .checkout-newsletter-optin input[type="checkbox"]', function () {		
		var parentContainer = $(this).closest('.checkout-newsletter-optin');
		var showContentWrapper = parentContainer.find('.show-content-wrapper');

		// for desktop
		if ($(window).width() > 480){
			$(parentContainer).find('.see-more-consent').removeClass('is-active');
			$(parentContainer).find('.see-less-consent').removeClass('is-active');
		}

		if ($(window).width() > 480 && $(this).prop("checked") == true) {
			$(parentContainer).find('.secondary-text').addClass('is-active');
		} else if ($(window).width() > 480 && $(this).prop("checked") == false) {
			$(parentContainer).find('.secondary-text').removeClass('is-active');
		}

		// for mobile
		if ($(window).width() < 480 && $(this).prop("checked") == true && !$(showContentWrapper).length) {
			$(parentContainer).find('.secondary-text').addClass('is-active');

		} else if ($(window).width() < 480 && $(this).prop("checked") == false && !$(showContentWrapper).length) {
			$(parentContainer).find('.secondary-text').removeClass('is-active');
		}

		// for mobile & Show btn
		if ($(window).width() < 480 && $(this).prop("checked") == true && $(showContentWrapper).length) {
			$(parentContainer).find('.primary-text').addClass('show-text');
			$(parentContainer).find('.see-more-consent').addClass('is-active');

		} else if ($(window).width() < 480 && $(this).prop("checked") == false && $(showContentWrapper).length) {
			$(parentContainer).find('.primary-text').removeClass('show-text');
			$(parentContainer).find('.see-more-consent').removeClass('is-active');

			if(!$('.see-more-consent').hasClass('is-active')){
				$(parentContainer).find('.secondary-text').removeClass('is-active');
				$(parentContainer).find('.see-less-consent').removeClass('is-active');
			}
		}
	});	
	// Show more content
	$modalCustomPlaceholder.on('click', '#cart-paypalexpress-popup .see-more-consent', function () {
		var parentContainer = $(this).parents('.checkout-newsletter-optin');
		$(this).removeClass('is-active');
		$(parentContainer).find('.secondary-text').addClass('is-active');
		$(parentContainer).find('.see-less-consent').addClass('is-active');
	});
	// Show less content
	$modalCustomPlaceholder.on('click', '#cart-paypalexpress-popup .see-less-consent', function () {
		var parentContainer = $(this).parents('.checkout-newsletter-optin');
		$(this).removeClass('is-active');
		$(parentContainer).find('.secondary-text').removeClass('is-active');
		$(parentContainer).find('.see-more-consent').addClass('is-active');
	});
	// MOdal close
	$modalCustomPlaceholder.on('click', '#cart-paypalexpress-popup .modal-close, #cart-paypalexpress-popup .modal-close-outer', function(e) {
		if($('body').attr('data-paymentMethod') === 'googlepay_Express') {
			window.location.href = window.returnUrl+'?googleAuthResult=false';
		} 
        if($('body').attr('data-paymentMethod') === 'paypalpay_Express') {
			window.location.href = window.returnUrl+'?paypalAuthResult=false';
		}
	});
}

// re-initialize Einstein Recommendation carousel
function initEinsteinRecommendations() {
	$(window).on("load", function() {
		setTimeout(function() {
			recommendations.init();
			// to reinit recommended product's quantity dropdown 
			$('.carousel-recommendations select').selectmenu();
			stickySideBarInit();
		}, 5000);	
	});
}

function screenResizeHandler() {
	// Store the window width
    var winWidth = $(window).width();

	$(window).on('resize orientationchange', function () {
		// to prevent calling of resize event in IOS devices while scrolling
        if ($(window).width() != winWidth) {
            // Update the window width for next time
            winWidth = $(window).width();            
			// Do stuff here
			var $recommendationCarousel = $('.recommendation-container .carousel-recommendations');			
			if ($recommendationCarousel.hasClass('slick-initialized')) {
				$recommendationCarousel.slick('destroy');
				recommendations.init();
				$('.carousel-recommendations select').selectmenu();
			}
        }
	});
}

function applyLongTextClass() {
    const $cartRedesign = $('.cart_page');
    const $window = $(window);

    $cartRedesign.find('.coupon-applied').each(function(i, e) {
        if ($cartRedesign.length && $window.width() < 768) {
            var strongElement = $(e).find('strong');
            if (strongElement.length && strongElement.html().length > 15) {
                strongElement.addClass("long-text");
            }
        }
    });
}

function initializeBonusProductView() {
    const $bonusItemPromo = $('.bonus-item-promo');
    const $selectBonus = $bonusItemPromo.find('.select-bonus');
    if ($selectBonus.length > 0 && $('.cart_page').length == 0 && $selectBonus.filter('.update').length == 0) {
      var hrefValue = $selectBonus.attr('href');
      bonusProductsView.show(hrefValue);
    }
}

// display slick slider for cart page mini recommendations
const cartPageMiniRecommendations = function () {
	$('html').removeClass('modal-open');
    return new Promise(function (resolve, reject) {
        util.waitForElement('.cart-mini-recommendation-container .cart-mini-recommendations')
            .then(function ($recommendations) {
                // If Slick is already initialized
                if ($recommendations.hasClass('slick-initialized')) {
                    customDropdown.init();
                    resolve($recommendations);
                } else {
					$(".tile-ajax-loader").hide();
                    // Initialize Slick
                    $recommendations.slick({
                        initialSlide: 0,
                        autoplay: false,
                        dots: false,
                        arrows: true,
                        swipe: true,
                        infinite: false,
                        speed: 150,
                        slidesToShow: 1,
                        swipeToSlide: 1,
                        fade: false,
                        cssEase: 'linear',
                        variableWidth: true,
                        nextArrow: '<div class="slick-next"><i class="icon icon-rightCarrot"></i></div>',
                        prevArrow: '<div class="slick-prev"><i class="icon icon-leftCarrot"></i></div>'
                    });

                    // Use a timeout fallback in case init event doesn't fire
                    let resolved = false;

                    $recommendations.one('init', function () {
                        if (!resolved) {
                            resolved = true;
                            customDropdown.init();
                            resolve($recommendations);
							analytics.cartCrossSellafterInit($recommendations);
                        }
                    });

                    // Fallback: resolve after a small delay anyway
                    setTimeout(function () {
                        if (!resolved) {
                            resolved = true;
                            customDropdown.init();
                            resolve($recommendations);
							analytics.cartCrossSellafterInit($recommendations);
                        }
                    }, 100);
                }
            })
            .catch(function (err) {
                console.warn('Error in cartPageMiniRecommendations:', err);
                reject(err);
            });
    });
};

//add product to cart from recommendation section
function addProductFromRecomendation(pid, qty, cartAction, prodContainer, $event) {
	if ($('.overlay').length == 0) {
        $('body').append('<div class="overlay"></div>')
        $('.overlay').css('display', 'block');
    }
	const $data = {
		"format": "ajax",
        "pid": pid,
        "isCartMiniCrosssell": true
	}
	$.post(Urls.addProduct, $data, function (data) {
		$(".overlay").remove();
		if (data.error) {
			// display error
            const $errEle = $(".cart-mini-recommendations .slick-active #a2c-error");
            $(".cart-mini-recommendations .slick-active #a2c-error").html(data.error).slideDown('fast', function () {
                setTimeout(function () {
                    $errEle.slideUp(500, function () {
                        // hide error after timeout
                        $(this).removeClass('active');
                    });
                }, 2000);
            });
		} else {
			const $existing = $('.cart-mini-recommendations.slick-initialized');
            if ($existing.length) {
                $existing.slick('unslick');
            }
            $('#primary').html(data);
			initializeAll();
			$('.minicart-link .cart-count').html($('.cart-item-quantity').html());
            cartPageMiniRecommendations();
			analytics.cartCrossSellAddToCart(prodContainer, $event);
		}
	}).fail(function (err) {
		reject(err.error);
	});
}

$(document).on('click', '.cart-mini-crosssell-slot .custom-dd .custom-dd-list-item', function () {
	// Handles the selection of a product tile in the minicart cross sell slot. 
	const $this = $(this);
	const pid = $(this).find('.color-swatch, .swatchanchor').data('pid');
	const targetContainer = $this.parents('.cart-mini-recommendations-tile');
	const params = {
		format: 'ajax',
		pid: pid,
		templaterender: 'product/cartminicrosssell',
		showswatches: true,
		showpricing: true,
		showpromotion: true,
		isclickable: true,
		showrating: true,
		disablebvseo: true,
		showbrandname: true,
		issliderimage: false,
		source: "cartMiniCrosssell",
		isminicartcrosssell: true
	};

	ajax.load({
		url: util.appendParamsToUrl(Urls.transactionalHitTile, params),
		target: targetContainer,
		callback: function () {
			customDropdown.init();
			$this.parents(".cart-mini-recommendations-tile").find(".product-tile").removeClass("tile-dropdown-open");
		},
	});
	
}).on('click', '.cart-mini-recommendations-tile .product-tile', function(e){
	if(!$(this).hasClass("tile-dropdown-open")) {
		// display quickview
		const $this = $(this);
		const $data = {
			"format": "ajax",
			"pid": $this.attr("data-itemid"),
			"source":'plpquickview',
		}
		$.ajax({
			url: Urls.transactionalHitTile,
			data: $data,
			type: 'GET'
		}).done(function (resp) {
			if(!resp.trim() == '') {
				$('.quick-shop-panel').removeAttr('style').addClass('opened');
				$('.crosssell-recommendation-modal').removeClass('active');
				localStorage.setItem('quickview', 'open_quickview');
				setTimeout(function(){$('.quick-shop-panel .add-to-cart-sticky').addClass('show')}, 600);
				$('html').addClass('filter-open modal-open');
				$('.quick-shop-panel .panel-body').html(resp);
				if (window.User.isCustomerAuthenticated && $('.quick-shop-panel .coming-soon-wrapper').length) {
					$('.quick-shop-panel .coming-soon-wrapper').removeClass('coming-soon-wrapper').addClass('coming-soon-wrapper_registered');
				}
				analytics.quickViewOpenFromCrosssell();
				customDropdown.init();
			}
		});
	}
}).on('click', '.cart-mini-recommendations-tile .add-to-cart', function(e){
	e.preventDefault();
	e.stopPropagation();
	const $event = e;
	const $this = $(this);
	const pid = $this.data('pid');
	const qty = $this.data('quantity');
	const cartAction = $(this).data('cartaction');
	const prodContainer = $this.closest('.cart-mini-recommendations-tile');
    addProductFromRecomendation(pid, qty, cartAction, prodContainer, $event);
});

function initializeAll() {
	cartPageMiniRecommendations();
	login.init();
	initializeEvents();
	productTile.init();
	isGift();
	giftMessage();
	updateCart();
	cartCount();
	summarysection.init();

	if (SitePreferences.STORE_PICKUP) {
		cartStoreInventory.init();
	}

	account.initCartLogin();
	account.characterLimitEvents();

	setTimeout(() => {
		recommendations.init();
		wishlist.checkWhishlistProduct(window.User.wishlistProducts);
		checkoutReinsurancePopup();
		initEinsteinRecommendations();
		screenResizeHandler();
	}, 5000);

	cartPayPalExpressPopup();
	initPromoMessage();
	reinsuranceCheckout.reinsuranceCartClickEvent();

	setTimeout(() => {
		reinsuranceCheckout.reinsuranceCartOnLoad();
	}, 500);

	applyLongTextClass();

    $(document).on('ready', function (e) {
        initializeBonusProductView();
    });
}

export default {
	init : function() {
		initializeAll();
	},
	cartPayPalExpressPopup,
	postAppleErr,
	getApplePayDisplayNationality,
	getPayPalExpressConsentModal
}
